
export const ROUTES = {
    HOME: '/',
    BOARD: '/board/:id',
    WELCOME: '/welcome',
    AUTH: '/auth/:type',
    NOT_FOUND: '*',
  };
  